import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import { useGlobalStore } from '@old/global-store/use-store';
import * as UI from '@siloreal:shared:ui';
import * as HOOKS from '@siloreal:shared:hooks';
import { SilobagTaggingModal } from '../../silobag-tagging-modal';

const ORGANIZATION_TOOLTIP =
  'Para habilitar el etiquetado masivo, seleccioná tu organización en el selector principal.';

type Props = {
  interactionId: string;
  disabled?: boolean;
};

function getSelectedIds(selectionModel: GridRowSelectionModel): string[] {
  return Array.from(selectionModel.ids).map(String);
}

export function TagInteraction({ interactionId, disabled }: Props) {
  const i18n = HOOKS.useLocale();
  const explorer = UI.collection.useExplorer();
  const selectedOrganizationId = useGlobalStore((state) => state.organizationId);
  const userOrganizationId = useGlobalStore((state) => state.userOrganizationId);
  const [taggingIds, setTaggingIds] = useState<string[] | null>(null);
  const isOwnOrganization =
    selectedOrganizationId !== undefined && selectedOrganizationId === userOrganizationId;
  const isDisabled = Boolean(disabled) || !isOwnOrganization || taggingIds !== null;
  const label = i18n.t('temp.common.tagging');
  const tooltipContent = isOwnOrganization ? label : ORGANIZATION_TOOLTIP;

  const handleSelectionConfirm = (selectionModel: GridRowSelectionModel): void => {
    const selectedIds = getSelectedIds(selectionModel);
    if (isOwnOrganization && selectedIds.length > 0) setTaggingIds(selectedIds);
  };

  const handleClick = (): void => {
    if (!isOwnOrganization) return;

    explorer.startSelection({
      id: interactionId,
      onConfirm: handleSelectionConfirm,
    });
  };

  return (
    <>
      <UI.Tooltip content={tooltipContent} tid={`${interactionId}-tooltip`}>
        <span
          tabIndex={isOwnOrganization ? undefined : 0}
          aria-label={isOwnOrganization ? undefined : ORGANIZATION_TOOLTIP}
          style={{ display: 'inline-flex' }}
        >
          <UI.Button
            type="button"
            variant="spotlight"
            uppercase={false}
            disabled={isDisabled}
            ariaLabel={label}
            icon={<SellOutlinedIcon fontSize="small" />}
            onClick={handleClick}
            tid={`${interactionId}-btn`}
          />
        </span>
      </UI.Tooltip>

      {taggingIds ? (
        <SilobagTaggingModal open silobagIds={taggingIds} onClose={() => setTaggingIds(null)} />
      ) : null}
    </>
  );
}
